import lodash from 'lodash'

///
/// По фильтру состояния грида определяет поля, используемые в фильтре
/// 
/// filterValue - значение фильтра (из сосотояния)
export function getStateFilterFields(filterValue) {
    if (!filterValue) {
        return [];
    }
    // поля фильтра текущего состояния
    const flatten = (arr) => {
        if (Array.isArray(arr[0])) {
            return arr.reduce(function(done,curr) {
                return done.concat(flatten(curr));
            }, []);
        } else if (Array.isArray(arr) && arr.length >=3) {
            return {
                fieldName : arr[0], 
                condition :arr[1], 
                fieldValue : arr[2]
            };
        } else {
            return [];
        }
    }

    let result = flatten(filterValue);
    if (Array.isArray(result)) {
        return result;
    }

    return lodash.isEmpty(result) ? [] : [result];
}

///
/// удаляет элементы из фильтра
/// 
/// filterValue     - фильтр
/// removableFields - удаляемые поля
///
export function correctFilterItems(filterValue, removableFields) {
    if (!filterValue || filterValue.length == 0) {
        return [];
    }
    
    let isComposite =  Array.isArray(filterValue[0]);
    if (isComposite) {
        let res = [];
        // признак того, что это составной элемент
        for (let i = 0; i < filterValue.length; i += 2) {
            const filterItem = filterValue[i];
            const condition = (i > 1) ? filterValue[i - 1] : null;
            let subFilterItem = correctFilterItems(filterItem, removableFields);
            if (condition && subFilterItem && res.length > 0) {
                res.push(condition)
            }
            if (subFilterItem) {
                res.push(subFilterItem)
            }
        } 
        if (res.length == 0){
            return null;
        } else if (res.length == 1) {
            return res[0];
        }
        return res;

    } else {
        // атомарный элемент, соответствующий полю
        return removableFields.includes(filterValue[0]) ? null : filterValue
    }
}

///
/// Очистить фильтр в состоянии грида
///
/// gridState - состояние грида
///
export function clearGridStateFilter(gridState) {
    var stateCopy = Object.assign({}, gridState);
    stateCopy.filterValue = null;

    stateCopy.columns.forEach(clm => {
        delete clm.filterValue;
        delete clm.selectedFilterOperation;
        delete clm.filterValues;
    })
    return stateCopy;
}

///
/// ищет элемент фильтра по названию поля (если не нашел, возвращает null)
/// 
/// filterValue - значение фильтра
/// fieldName   - название поля
///
export function getFilterItemByName(filterValue, fieldName) {
    let items = getStateFilterFields(filterValue) || [];

    var index = lodash.findIndex(items, {fieldName : fieldName});

    if(index >= 0){
        return {index : index, item : items[index]};
    }

    return null;
}
///
/// удаляет поля фильтра из состояния
///
/// state  - состояние
/// fields - удаляемые поля
///
export function removeFilterItems(state, fields) {
    var stateCopy = Object.assign({}, state);
    let correctedFilterValue = correctFilterItems(stateCopy.filterValue, fields);
    for (let i = 0; i < fields.length; i++) {
        const field = fields[i];
        let columnIndex = lodash.findIndex(stateCopy.columns, {dataField: field});
        if (columnIndex >= 0) {
            let column = stateCopy.columns[columnIndex]
            let correctedColumn = {
                visibleIndex : column.visibleIndex,
                dataField :column.dataField,
                dataType :column.dataType,
                visible: column.visible,
            } 
            stateCopy.columns.splice(columnIndex, 1, correctedColumn)
        }
    }
    stateCopy.filterValue = correctedFilterValue;
    return stateCopy;
}